export const buttonPreset = {
  button: {
    root: {
      borderRadius: '0.5rem',
      paddingX: '1rem',
      paddingY: '0.5rem',
      label: {
        fontWeight: '600',
      },
    },
    colorScheme: {
      light: {
        root: {
          primary: {
            background: 'var(--brand--50)',
            hoverBackground: 'var(--brand--60)',
            activeBackground: 'var(--brand--70)',
            borderColor: 'var(--brand--50)',
            hoverBorderColor: 'var(--brand--60)',
            activeBorderColor: 'var(--brand--70)',
            color: '#ffffff',
            hoverColor: '#ffffff',
            activeColor: '#ffffff',
            focusRing: {
              color: 'var(--brand--50)',
              shadow: '0 0 0 3px rgba(21, 93, 252, 0.12)',
            },
          },
          secondary: {
            background: 'var(--brand--5)',
            hoverBackground: 'var(--brand--10)',
            activeBackground: 'var(--brand--20)',
            borderColor: 'var(--brand--5)',
            hoverBorderColor: 'var(--brand--10)',
            activeBorderColor: 'var(--brand--20)',
            color: 'var(--brand--60)',
            hoverColor: 'var(--brand--70)',
            activeColor: 'var(--brand--70)',
            focusRing: {
              color: 'var(--brand--50)',
              shadow: '0 0 0 3px rgba(21, 93, 252, 0.12)',
            },
          },
          danger: {
            background: '#C92924',
            hoverBackground: '#B72521',
            activeBackground: '#9B201D',
            borderColor: '#C92924',
            hoverBorderColor: '#B72521',
            activeBorderColor: '#9B201D',
            color: '#ffffff',
            hoverColor: '#ffffff',
            activeColor: '#ffffff',
            focusRing: {
              color: '#C92924',
              shadow: '0 0 0 3px rgba(201, 41, 36, 0.25)',
            },
          },
        },
        outlined: {
          secondary: {
            hoverBackground: 'var(--neutral--5)',
            activeBackground: 'var(--neutral--10)',
            borderColor: 'var(--neutral--30)',
            color: 'var(--neutral--60)',
          },
        },
        text: {
          primary: {
            hoverBackground: 'rgba(21, 93, 252, 0.04)',
            activeBackground: 'rgba(21, 93, 252, 0.12)',
            color: 'var(--brand--60)',
          },
          danger: {
            hoverBackground: 'rgba(201, 41, 36, 0.04)',
            activeBackground: 'rgba(201, 41, 36, 0.12)',
            color: '#C92924',
          },
        },
      },
    },
  },
};
